import { useMutation } from 'react-query';

import { getBoardWbsInit as mutationFn } from 'api/endPoints/getBoardWbsInit';

export const useMutationGetWBSOptions = () => {
    return useMutation<IGetWBSOptionsResponse[], QueryError, IGetWBSOptionsPayload>((params) => mutationFn(params));
};

interface IGetWBSOptionsPayload {
    versionId?: number;
}

interface IGetWBSOptionsResponse {
    id: number;
    activityId: string;
    name: string;
}
